import events from '../events';
const initState = {
    error: [],
    success: null,
    status: 0,
};
export function getBasketAmount() {
    return {
        ...initState,
        count: 0,
        init() {
            events.onCartBadgeUpdate.subscribe(count => {
                this.count = count;
            });
            events.onBasketUpdated.subscribe(data => {
                this.count = data.basket.products.reduce((sum, item) => sum + item.quantity, 0);
            });
        },
    };
}
